import { Component } from '@angular/core';
import { ChartConfiguration } from 'chart.js';

@Component({
  selector: 'app-general-analytics',
  templateUrl: './general-analytics.component.html',
  styleUrls: ['./general-analytics.component.css'],
})
export class GeneralAnalyticsComponent {
  //User Engagement Line Chart Data

  public userEngagementChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  //Performance Trends Line Chart Data

  public performanceTrendsChartData: ChartConfiguration<'line'>['data'] = {
    labels: ['05:00', '10:00', '15:00', '20:00', '25:00', '30:00'],
    datasets: [
      {
        data: [0.1, 0.2, 0.3, 0.1, 0.2],
        label: 'Series B',
        borderColor: 'purple',
        backgroundColor: 'transparent',
        borderWidth: 4,
        tension: 0.4,
      },
    ],
  };

  //Overall Platform Usage Bar Chart Data

  public overallPlatformUsageChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Service 1', 'Service 2', 'Service 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Bank A', backgroundColor: '#0058e9' },
    ],
  };

  //Error & Issue Tracking Bar Chart Data

  public errorAndIssueChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Error 1', 'Error 2', 'Error 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Error A', backgroundColor: '#0058e9' },
    ],
  };

  //Compliance & Security Bar Chart Data

  public complianceAndSecurityChartData: ChartConfiguration<'bar'>['data'] = {
    labels: ['Error 1', 'Error 2', 'Error 3'],
    datasets: [
      { data: [3, 4.5, 7], label: 'Error A', backgroundColor: '#0058e9' },
    ],
  };
}
